<!-- Mobile Filter Button (visible only on mobile) -->
<div class="mobile-filter-button-container">
  <app-button
    [label]="'Filters'"
    [buttonStyle]="'outlined'"
    [icon]="''"
    (handleClick)="visible.set(true)"
    [fullWidth]="true"
  ></app-button>
  <div class="filter-button-icon"></div>
</div>

<!-- Mobile Filter Sidebar -->

<p-drawer
  [(visible)]="visible"
  position="bottom"
  [style]="{ height: '500px' }"
  styleClass="mobile-filters-sidebar"
>
  <ng-template #header>
    <span class="filters-sidebar-title">Filters</span>
  </ng-template>

  <div class="mobile-filters-content">
    <!-- Status Dropdown -->
    <div class="mb-4 status-wrapper">
      <p-select
        [options]="statusOptions()"
        [(ngModel)]="selectedStatus"
        placeholder="Status"
        [style]="{ width: '100%' }"
        [showClear]="true"
        (onChange)="onFiltersChanged()"
      ></p-select>
      <img
        src="assets/img/icons/filters/filters.svg"
        alt="filters"
        class="status-icon-inside"
        width="16"
        height="16"
      />
    </div>

    <!-- Sort By Dropdown -->
    <div class="mb-4 sort-by-wrapper">
      <p-select
        [options]="sortOptions()"
        [(ngModel)]="selectedSortOption"
        placeholder="Sort By"
        [style]="{ width: '100%' }"
        [showClear]="true"
        (onChange)="onFiltersChanged()"
      ></p-select>
      <img
        src="assets/img/icons/filters/sort.svg"
        alt="sort"
        class="sort-icon-inside"
        width="16"
        height="16"
      />
    </div>

    <!-- Action Buttons -->
    <div class="grid">
      <div class="col-6">
        <app-button
          [label]="'Clear Filters'"
          [buttonStyle]="'outlined'"
          (handleClick)="onClearFilters()"
          [fullWidth]="true"
        ></app-button>
      </div>
      <div class="col-6">
        <app-button
          [label]="'See Results'"
          [buttonStyle]="'primary'"
          (handleClick)="onApplyFilters()"
          [fullWidth]="true"
        ></app-button>
      </div>
    </div>
  </div>
</p-drawer>
